// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2381":"4401ebb9df45d1ee","39710":"c858ffe069677e91","45415":"76d1bffee13f7751","81599":"c9840b325a46fb65"}[chunkId] + ".css";
};